export const QA_NAME_APPLICANT_IDENTITY_NAME = 'applicantIdentityName'

export const QA_NAME_APPLICANT_IDENTITY_NEW_BADGE = 'applicantIdentityNew'

export const APPLICANT_NEW_BADGE_TEXT_COLOR = 'var(--color-info)'
